export default __webpack_public_path__ + "static/media/home_unselected.bf502ca3.svg";